import { Component, OnInit, Input } from '@angular/core';
import { SemKeywordsV1Component } from './../sem-keywords-v1/sem-keywords-v1.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetLibraryService } from '../../services/widget-library.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import * as jQuery from 'jquery';
@Component({
	selector: 'app-sem-keywords-v5',
	templateUrl: './sem-keywords-v5.component.html',
	styleUrls: ['./sem-keywords-v5.component.css']
})
export class SemKeywordsV5Component extends SemKeywordsV1Component implements OnInit, WidgetCore {
	@Input() nodatamessage;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true
	};
	public cssClassesR10: any = {
		pagerLeftArrow: '',
		pagerRightArrow: '',
		pagerNext: 'datatable-last-text',
		pagerPrevious: 'datatable-first-text',
		sortAscending: 'fa fa-long-arrow-up',
		sortDescending: 'fa fa-long-arrow-down'
	};
	public cssClassesR5: any = {
		pagerLeftArrow: 'datatable-icon-left',
		pagerNext: 'datatable-icon-skip',
		pagerPrevious: 'datatable-icon-prev',
		pagerRightArrow: 'datatable-icon-right',
		sortAscending: 'datatable-icon-down',
		sortDescending: 'datatable-icon-up'
	};

	public paginationLimit = 5;
	public defaultSort: any;
	page: number = 0;
	expand: any = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected widgetLibraryService: WidgetLibraryService
	) {
		super(analyticsService, analyticsDataModel, widgetLibraryService);
	}
	ngOnInit() {
		if (this.sectionclass == 'sem_keywords_R25') {
			this.paginationLimit = 10;
		}
		super.ngOnInit();
		if (!this.nodatamessage || this.nodatamessage === 'undefined') {
			this.nodatamessage = 'No data to display';
		}
		this.defaultSort =
			this.datatableconfig.sortBy && typeof this.datatableconfig.sortBy !== 'string' ? this.datatableconfig.sortBy : [];
	}
	ngOnDestroy() {
		super.ngOnDestroy();
	}
	changePage(row) {
		let temp = row;
		if (row == temp) {
			this.page = this.page + 1;
		}
	}
	onPageChange(event) {
		this.page = this.page + 1;
	}
	sortApplied() {
		this.page = this.page + 1;
	}
}
